import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CommentList from '../../components/Posts/CommentList';
import LikeList from '../../components/Posts/LikeList';
import RoomerPostDetails from '../../components/Posts/RoomerPostDetails';
import Dashboard from '../../components/Dashboard';
import {
  getPostDetail,
  getPostComments,
  deleteComment,
  getPostLikes
} from '../../redux/modules/post/action';

const ROWS_PER_PAGE = 10;

class ViewRoomerPost extends React.Component {
  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE,
    likePage: 0
  };

  async componentDidMount() {
    const { dispatch, match } = this.props;
    const { rowsPerPage, page, likePage } = this.state;

    await dispatch(getPostDetail(match.params.postId));
  }

  handleChangePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getPostComments(match.params.postId, page, rowsPerPage));
  };

  handleChangeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPostComments(match.params.postId, page, event.target.value));
  };

  handleChangeLikePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ likePage: page });
    dispatch(getPostComments(match.params.postId, page, rowsPerPage));
  };

  handleChangeLikeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { likePage } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPostComments(match.params.postId, likePage, event.target.value));
  };

  removeComment = (commentId) => {
    const { dispatch, match } = this.props;
    const postId = match.params.postId;

    dispatch(deleteComment(postId, commentId));
  }

  render() {
    const {
      postDetails,
    } = this.props;

    const { rowsPerPage, page, likePage } = this.state;

    return (
      <Dashboard>
        <RoomerPostDetails
          postDetails={postDetails}
        />
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    postDetails: state.post.details,
    message: state.user.message
  }
}

ViewRoomerPost.propTypes = {
  initialValues: PropTypes.object,
  isVerified: PropTypes.bool,
  isActive: PropTypes.bool,
}

ViewRoomerPost.defaultProps = {
  isVerified: false,
  isActive: false
}

export default connect(mapStateToProps)(ViewRoomerPost);
